import css from '../WalletExtraDesktop.module.scss'
import React from 'react'

import DataTestId from 'meta/dataTestId'
import { Breakpoints } from 'meta/layout/breakpoints'
import { IEventData } from 'meta/pages/v4/event'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { GridColumn } from 'components/Layout/Grid'
import { useWalletEventTicketCodes } from 'hooks/useWallet'

import UserExtraContainer from '../UserExtra/UserExtraContainer'
import UserExtraSkeleton from '../UserExtra/UserExtraSkeleton'

interface Props {
  walletEventData: IWalletEvent
  eventData: IEventData
}

const UserExtras: React.FC<Props> = (props) => {
  const { walletEventData, eventData } = props
  const { id, count } = walletEventData

  const eventTicketCodesData = useWalletEventTicketCodes({ eventIdOrCodeUrl: String(id) })

  return (
    <GridColumn
      gridColumnStart={{ [Breakpoints.laptop]: 2 }}
      gridColumnEnd={{ [Breakpoints.laptop]: 16 }}
      className={css.tickets}
      data-testid={DataTestId.wallet.userExtraDesktopContainer}
    >
      {!eventTicketCodesData && <UserExtraSkeleton />}
      {eventTicketCodesData &&
        eventTicketCodesData.length > 0 &&
        eventTicketCodesData.map((elem, key) => (
          <React.Fragment key={key}>
            <UserExtraContainer cod={elem.cod} walletEventData={walletEventData} eventData={eventData} idx={key} />
            {key !== count - 1 && <div className={css.cover} />}
          </React.Fragment>
        ))}
    </GridColumn>
  )
}

export default UserExtras
